export const menuItems = [
  {
    title: 'cmp.header',
    options: [
      { url: '/customers-management', title: 'cmp.header' },
    ],
  },
];
